import { Formik } from 'formik';
import React from 'react';
import { Buttons, CancelButton, ModalCard, Button, Form, FormMessage, Field, HelpTooltip } from '~/components';
import * as Yup from 'yup';
import { FieldResourceSelect } from './ResourceSelect';
import { useForm } from '~/hooks';
import { useApi, useToast, useWorkspace } from '~/contexts';
import styled from 'styled-components';

const Content = styled.div`
  display: grid;
  row-gap: 1.25rem;
`;

const ContentRow = styled.div`
  display: flex;
  align-items: center;
`;

function ReassignAllocationsConfirmation({ project, resource, onSubmit, onClose }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const toast = useToast();
  const [{ isSubmitting, status, message }, form] = useForm();

  const handleSubmit = async (values) => {
    form.submit(values);

    try {
      await api.www.workspaces(workspace.id).allocations().projectSchedule.reassignAllocations(project.id, {
        sourceResourceTypeId: resource.resourceType,
        sourceResourceId: resource.id,
        targetResourceTypeId: values.targetResource.resourceType,
        targetResourceId: values.targetResource.id,
        includePastAllocations: values.includePastAllocations,
      });

      onClose();
      onSubmit();
      toast.success('Allocations have been reassigned.');
      form.done();
    } catch ({ message }) {
      form.error({ message });
    }
  };

  return (
    <ModalCard title="Reassign Allocations" onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={{
          targetResource: null,
          includePastAllocations: false,
        }}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          targetResource: Yup.mixed().required().label('Resource'),
        })}>
        <Form>
          <ModalCard.Body>
            <Content>
              <ContentRow>
                Reassign allocations on the {project.name} project within {project.client.name}.
              </ContentRow>
              <ContentRow>From: {resource.name}</ContentRow>
              <ContentRow>
                To:
                <span style={{ display: 'inline-flex', verticalAlign: 'middle', marginLeft: '0.5rem' }}>
                  <FieldResourceSelect
                    name="targetResource"
                    placeholder="Member or Resource Placeholder"
                    style={{ width: '25rem' }}
                  />
                </span>
              </ContentRow>
              <ContentRow>
                <Field.Checkbox name="includePastAllocations" label="Reassign past allocations" />
                <HelpTooltip
                  style={{ marginLeft: '.5rem' }}
                  message="If unchecked, only allocations ending today or later will be reassigned."
                />
              </ContentRow>
            </Content>
            {status && <FormMessage.Error spaceTop>{message}</FormMessage.Error>}
          </ModalCard.Body>
          <ModalCard.Footer>
            <Buttons align="right">
              <CancelButton onClick={onClose}>Cancel</CancelButton>
              <Button type="submit" isLoading={isSubmitting}>
                Reassign Allocations
              </Button>
            </Buttons>
          </ModalCard.Footer>
        </Form>
      </Formik>
    </ModalCard>
  );
}

export default ReassignAllocationsConfirmation;
